import { motion } from "framer-motion";
import { Star, Quote } from "lucide-react";

const testimonials = [
  { n: "Ajay Tiwari", b: "KTM Duke 390 / Lucknow", q: "I sold my Duke in just 15 minutes. The price they gave was better than any dealer in the city. So easy." },
  { n: "Aman Verma", b: "Royal Enfield Continental GT / Lucknow", q: "No long talks, no waiting. The team came home, checked the bike, and paid me on the spot. Best service." },
  { n: "Vikas Singh", b: "Triumph Speed 400 / Lucknow", q: "Everything was clear from start to end. They told me how the price was made. Felt very honest and modern." },
];

export default function TrustStats() {
  return (
    <section data-testid="trust-section" className="relative py-24 md:py-36 overflow-hidden bg-[#0D0F12]">
      <div className="absolute inset-0 grid-bg opacity-10" />

      <div className="relative max-w-[1400px] mx-auto px-6 md:px-12">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7 }}
          className="text-center max-w-2xl mx-auto"
        >
          <span className="text-xs font-mono tracking-[0.3em] uppercase text-[#00cccc]">// Trusted by Riders</span>
          <h2 className="mt-4 text-4xl sm:text-5xl lg:text-6xl font-black leading-tight tracking-tight">
            Words from the <span className="text-gradient-cyan">riders.</span>
          </h2>
        </motion.div>

        <div className="mt-16 grid md:grid-cols-3 gap-5">
          {testimonials.map((t, i) => (
            <motion.div
              key={t.n}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: i * 0.1 }}
              className="relative p-7 rounded-2xl glass hover:border-[#00cccc]/40 transition-all"
              data-testid={`testimonial-${i + 1}`}
            >
              <Quote className="absolute top-5 right-5 w-7 h-7 text-[#00cccc]/20" />
              <div className="flex gap-1 mb-4">
                {Array.from({ length: 5 }).map((_, k) => (
                  <Star key={k} className="w-3.5 h-3.5 fill-[#00cccc] text-[#00cccc]" />
                ))}
              </div>
              <p className="text-zinc-300 leading-relaxed">"{t.q}"</p>
              <div className="mt-5 pt-4 border-t border-white/10">
                <div className="text-sm font-semibold text-white">{t.n}</div>
                <div className="text-xs font-mono text-zinc-500 mt-0.5">{t.b}</div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
